import type { FC } from 'react'

import './index.styles.css'
interface Props {
  d: string | null
}

const Link: FC<Props> = ({ d }) => {
  if (!d) return null

  return <path className={'Link_link'} d={d} />
}

export default Link
